export const VORTEX_INTEGRATION = Object.freeze({
  path: "/vortex-vault.html",
  label: "Open Vortex Vault",
  repository: "https://github.com/MagnetosphereLabs/VortexVault",
  license: "AGPL-3.0",
  dataBoundary: "The shell never receives the Vortex vault key or decrypted vault records.",
});
